// Cognito config sourced exclusively from build-time env vars. CRA inlines
// process.env.REACT_APP_* into the bundle at build, so values are baked in
// per environment by the deploy workflow:
//   - deploy-dev.yml injects the dev pool/client IDs from SSM
//   - deploy-prod.yml promotes the dev-built bundle as-is (no rebuild),
//     so prod gets whatever IDs the dev workflow injected
//
// Earlier this file branched on REACT_APP_ENVIRONMENT and hardcoded a
// legacy-account pool/client (us-east-1_6yLySUYLl / 11p8k29fmkig...) as
// fallbacks. That pool no longer exists post account-cutover (2026-05-09),
// so the fallbacks silently broke dev sign-in. No more fallbacks.

const userPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID;
const userPoolClientId = process.env.REACT_APP_COGNITO_CLIENT_ID;

if (!userPoolId || !userPoolClientId) {
  throw new Error(
    'Cognito config missing: REACT_APP_COGNITO_USER_POOL_ID and ' +
      'REACT_APP_COGNITO_CLIENT_ID must be set at build time. ' +
      'Production builds inject these via .github/workflows/deploy-{dev,prod}.yml.'
  );
}

export const cognitoConfig = { userPoolId, userPoolClientId };
